module.exports = __webpack_public_path__ + "static/pic04-0ef04672312779908b72088876a33ca0.jpg";